module.exports = __webpack_public_path__ + "templates/category.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/restaurant/templates/category.html
// module id = 80a/
// module chunks = 1